import React from 'react';

import _Base from './../_Base';

import {Button} from '@components';
import paths from '@paths';
import {Props} from './types';

import './index.scss';

const SendSuccessMail = (props: Props) => {
  return (
    <_Base
      title={props.title}
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size="xs"
    >
      <div className="a__delete-modal">
        <div className="w__message">
          追加したユーザーに登録完了メールを送信しますか？
        </div>
        <div className="w__modal-buttons">
          <Button.Normal
            text="キャンセル"
            onClick={() => {
              props.history.push(paths.users.main);
              props.handleCloseModal(!props.isModal);
            }}
          />
          <Button.Normal
            text="送信する"
            onClick={props.onClick}
            color="yellow"
            loading={props.loading}
          />
        </div>
      </div>
    </_Base>
  );
};
export default SendSuccessMail;
